export class POLine { 
   Index:any;
       PL_SEQ :any;     
          PL_INVOICE_NO :any;
          PL_LINE_NO :any;
          PL_NATURE_OF_EXPENSE:any='';
          PL_NATURE_OF_EXPENSE_DESCRIPTION:any='';
          PL_TYPE:any;
          PL_UOM_CODE :any='';
          PL_QUANTITY :any=0;
          PL_AMOUNT_TO_VENDOR:number=0;
          PL_GST_GROUP_CODE :any='';
          PL_GST_GROUP_CODE_DESCRIPTION :any='';
          PL_HSN_SAC_CODE :any='';
          PL_UOM :any;
          PL_TDS_AMT :any; 
          PL_GST_BASE_AMT :any;
          PL_GST_AMOUNT :any;
          PL_DIRECT_UNIT_COST :any=0; 
          PL_NATURE_OF_DEDUCTION :any='';
          PL_NATURE_OF_DEDUCTION_DESCRIPTION :any='';
          PL_LINE_AMOUNT :any;
          PL_DESCRIPTION :any='';
          PL_CREATED_BY :any;
          PL_MODIFIED_BY :any;
          sqlflags :any;
          PL_ACTIVE :any;
}
